import { Pipe, PipeTransform } from '@angular/core';
import { DIALOG_MODE_IDENTIFIER, ND } from '@pt/pt-models';

@Pipe({
  name: 'removeHelpPrefix',
  pure: false
})

export class RemoveHelpPrefixPipe implements PipeTransform {

  transform(value: string): string {
    if (typeof value === 'undefined' || value === 'null' || value === null || value === undefined) {
      return ND;
    } else {
      return value.replace(DIALOG_MODE_IDENTIFIER, '');
    }
  }
}
